var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame165(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 186,
    viewBox: "0 0 314 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4766 120.079C74.1389 119.634 75.5563 118.546 76.4167 117.056C77.2772 115.565 77.5104 113.794 77.065 112.132C76.6196 110.47 75.532 109.052 74.0416 108.192C72.5512 107.331 70.78 107.098 69.1176 107.544C67.4553 107.989 66.038 109.076 65.1775 110.567C64.317 112.057 64.0838 113.829 64.5292 115.491C64.9747 117.153 66.0622 118.571 67.5526 119.431C69.043 120.292 70.8142 120.525 72.4766 120.079ZM73.3163 123.213C67.0359 124.896 63.0499 130.478 64.4405 135.668C64.5346 136.019 64.8843 136.221 65.2353 136.127L86.7717 130.356C87.1227 130.262 87.3246 129.913 87.2305 129.562C85.8399 124.372 79.5967 121.53 73.3163 123.213Z",
    fill: "#FCFF78"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.0463,
    y: 98.5349,
    width: 61.3799,
    height: 61.3799,
    rx: 30.69,
    transform: "rotate(-15 35.0463 98.5349)",
    stroke: "white",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.403 93.3342L289.304 47.0056",
    stroke: "#EDF9FF",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.026 106.857L292.927 60.5285",
    stroke: "#EDF9FF",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.65 120.38L296.551 74.0515",
    stroke: "#EDF9FF",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.642991,
    y: 83.976,
    width: 321.974,
    height: 104.206,
    rx: 19.475,
    transform: "rotate(-15 0.642991 83.976)",
    stroke: "white",
    strokeWidth: 1.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_3333"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 83.6048,
    width: 323.024,
    height: 105.256,
    rx: 20,
    transform: "rotate(-15 0 83.6048)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame165);
export default __webpack_public_path__ + "static/media/Frame 165.dee593b2a4ac105a151d449b6bd6866f.svg";
export { ForwardRef as ReactComponent };